import {
	ContentRecommendation,
	EmptyLoadingElement,
} from '@/components/content/ContentRecommendation';

const emsName = 'DPV2FooterDpPaymentMethodsMobile';

export const DpPaymentMethods = () => (
	<ContentRecommendation
		id={`footer-${emsName}`}
		properties={{ emsName }}
		loadingElement={<EmptyLoadingElement />}
	/>
);
